export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-taged/index.js